export default __webpack_public_path__ + "static/media/retro6.047cccd2.jpg";